<script setup lang="ts"></script>

<template>
	<div class="col-span-2">
		<slot />
	</div>
</template>
